export default [
  {
    icon: 'mdi-delete',
    title: 'Hapus Fasilitator Binaan',
    event: 'onDelete',
    akses: 'psp-pelatih-ahli-koordinator.delete',
  },
];
